export default __webpack_public_path__ + "static/media/fridge2-beforeA-2048w.0f4fdeb5.webp";